let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("3UjsV")]).then(() => parcelRequire('ZA4S4'));